"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    filled: {
        backgroundColor: colors_1.default.BLUE,
    },
    notFilled: {
        backgroundColor: colors_1.default.WHITE,
        borderColor: colors_1.default.BLUE,
        borderWidth: 1,
        color: colors_1.default.BLUE,
    },
    disabledFilled: {
        backgroundColor: colors_1.default.GRAY_3,
        borderColor: colors_1.default.GRAY_3,
        borderWidth: 1,
    },
    disbledNotFilled: {
        borderColor: colors_1.default.GRAY_3,
        borderWidth: 1,
    },
});
exports.default = styles;
